import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import Button from '@material-ui/core/Button'
import ActionModal from '../../../common/ActionModal'

const FactorContinueModal = ({ open, dismissFn, disregardFn, saveFn, t }) => (
  <ActionModal
    open={open}
    content={t('Factor Currently Being Edited')}
    dismissText={t('Cancel')}
    onDismiss={dismissFn}
    buttons={[
      <Button
        onClick={disregardFn}
      >
        {t('Cancel Changes')}
      </Button>,
      <Button
        color="primary"
        onClick={saveFn}
      >
        {t('Save And Continue')}
      </Button>
    ]}
  />  
)

FactorContinueModal.propTypes = {
  open: PropTypes.bool.isRequired,
  dismissFn: PropTypes.func.isRequired,
  disregardFn: PropTypes.func.isRequired,
  saveFn: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default translate()(FactorContinueModal)



// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Modals/Continue.js